import React, {useState} from 'react';
import styled from "styled-components"
import {Icon, Preloader} from "react-materialize";
import useFetch from "../../../Utilities/API/useFetch.react";

const StyledExportButton = styled.div`
  border: none;
  padding: 0;
  cursor: pointer;
  width: 20rem;
  color: ${(props) => props.darkMode ? 'white' : '#6B737D'};
  :hover {
    color: ${(props) => props.darkMode ? 'white' : '#0f82c5'};
    
    i {
      color: ${(props) => props.darkMode ? 'white' : '#0f82c5'};
      border: 1px solid ${(props) => props.darkMode ? 'white' : '#0f82c5'};
    }
  }
  
  .exporting {
   font-size: 1.4rem;
   display: flex;
   align-items: center;
   justify-content: center;
     .preloader-wrapper {
      width: 15px;
      height: 15px;
     }
     span {
      padding-left: 0.7rem;
     }
  }
  
  i {
    margin-top: 2px;
    border: 1px solid ${(props) => props.darkMode ? 'white' : '#6B737D'};
    border-radius: 4px;
    font-size: 1.6rem;
    color: ${(props) => props.darkMode ? 'white' : '#6B737D'};
  }
`

const ExportButton = ({apiURL, darkMode=false}) => {
  const [downloading, setDownloading] = useState(false);
  const [fetchUrl] = useFetch();

  const handleClick = async () => {
    setDownloading(true);
    setTimeout(() => {
      setDownloading(false);
    }, 3000);
    // setDownloading(false);
  }
  return (
    <StyledExportButton className={'tb-export-btn'} darkMode={darkMode} disabled={downloading} onClick={handleClick}>
      {
        downloading ?
          <div className={'exporting'}><Preloader active color={'blue'} flash={false} /><span>Exporting...</span></div> :
          <div className={'exporting'}><Icon clasName={'file-download'}>file_download</Icon><span>Export Transactions</span></div>
      }
    </StyledExportButton>
  )
}

export default ExportButton;